import styled from 'styled-components';

import media from 'theme/media';
import zIndex from 'theme/zIndex';

const getJustifyContent = (props) => {
    if (props.isSearchBar || props.align === 'center') {
        return 'center';
    } else if (props.align === 'space-between') {
        return 'space-between';
    } else {
        return props.align === 'left' ? 'start' : 'flex-end';
    }
};

export const Container = styled.div`
    background-color: #fff;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    height: 0;
    pointer-events: none;
    z-index: ${zIndex.navBar};

    ${media.desktop1224} {
        display: block;
    }
`;
export const Inner = styled.div`
    box-sizing: border-box;
    margin: 0 auto;
    padding: ${(props) => (props.isSearchBar ? '0' : '16px')};
    position: absolute;
    right: 0;
    left: 0;
    top: 0;
    display: flex;
    justify-content: ${(props) => getJustifyContent(props)};
    max-width: 528px;

    ${media.tablet720} {
        padding: ${(props) => (props.isSearchBar ? '0' : '56px 16px')};
        max-width: 568px;
    }
    ${media.tablet1080} {
        max-width: 856px;
    }
    ${media.desktop1224} {
        margin: 0 auto;
    }
`;
